<template>
    <div class="legal">
        <div class="container mainPage">
            <div v-if="article && articleType == 'home.InformationPage'" class="grid">
                <div class="col-md-8 offset-md-2 col-bleed-y">
                    <h1>{{ article.title }}</h1>
                    <div v-html="article.body"></div>
                </div>
            </div>

            <div v-else-if="article && articleType == 'home.FreeFormPage'" class="grid">
                <div class="col-md-8 offset-md-2 col-bleed-y">
                    <h1>{{ article.title }}</h1>
                    <div v-for="b in article.body" v-bind:key="b.id">
                        <div v-if="b.type == 'paragraph'" v-html="b.value"></div>
                        <div v-if="b.type == 'html'" v-html="b.value"></div>
                        <div v-else-if="b.type == 'image'">
                            <img class="full-width" :src="baseUrl + '/scaled/1280/' + b.value.filename" :alt="b.value.title" />
                        </div>
                        <div v-else-if="b.type == 'image_with_link'" class="image_with_link">
                            <div v-if="b.value.image && b.value.alignment == 'left'" class="image_with_link_left">
                                <a :href="b.value.link" target="_blank"><img :src="baseUrl + '/scaled/200/' + b.value.image.filename" :alt="b.value.image.title" /></a>
                            </div>
                            <div>
                                <div><u>{{ b.value.title }}</u></div>
                                <div v-html="b.value.description"></div>
                            </div>
                            <div v-if="b.value.image && b.value.alignment == 'right'" class="image_with_link_right">
                                <a :href="b.value.link" target="_blank"><img :src="baseUrl + '/scaled/200/' + b.value.image.filename" :alt="b.value.image.title" /></a>
                            </div>                       
                        </div>
                        <div v-else-if="b.type == 'contact_person'" class="contact_person">
                            <div>
                                <a :href="b.value.link" target="_blank"><img v-if="b.value.photo" :src="baseUrl + '/scaled/200/' + b.value.photo.filename" :alt="b.value.photo.title" /></a>
                            </div>
                            <div>
                                <div><u>{{ b.value.title }}</u></div>
                                <div><b>{{ b.value.first_name }} {{ b.value.last_name }}</b></div>
                                <div>E-Mail: <a :data-meta="obfuscate(b.value.email)" @click="defuscate($event.target)" @mouseover="defuscate($event.target)">hier-klicken@zum.anzeigen</a></div>
                                <div>Tel: {{ b.value.telephone }}</div>
                            </div>
                        </div>
                        <div v-else-if="b.type == 'table'">
                            <TableSnippet :tableObject="b.value"></TableSnippet>
                        </div>
                    </div>
                </div>
            </div>
            
            <p v-if="errorLoadingArticle">Diese Seite existiert nicht.</p>

        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { obfuscate, defuscate } from '@/hbf-helper';
import TableSnippet from '@/components/TableSnippet.vue';

export default {
    name: 'BasicPageView',
    components: {TableSnippet},
    setup() {
        return {
            obfuscate,
            defuscate
        }
    },
    data() {
        return {
            article: null,
            errorLoadingArticle: false,
        }
    },
    methods: {
        init(articleId) {
            this.article = null;
            this.errorLoadingArticle = false;
            if (this.isNumeric(articleId)) {
                this.loadArticle(articleId);
            }
            else {
                let apiUrl = this.$store.getters.getApiUrl;
                axios
                    .get(apiUrl + 'pages/?slug=' + articleId)
                    .then(response => {
                        let searchResult = response.data;
                        if (searchResult.items && searchResult.items.length > 0) {
                            articleId = searchResult.items[0].id;
                            this.loadArticle(articleId);
                        }
                        else {
                            this.errorLoadingArticle = true;
                        }
                    });
            }
        },
        checkLinks() {
            var links = document.querySelectorAll(".mainPage a");
            for (var l = 0; l < links.length; l++){
                if (links[l].href.endsWith(".pdf")){
                    links[l].target = "_blank";
                }
                else if(links[l].href.startsWith("http") && !(links[l].href.includes("localhost") || links[l].href.includes("handball-bundesliga-frauen.de") || links[l].href.includes("handball-frauen-bundesliga.de"))) {
                    links[l].target = "_blank";
                    links[l].rel = "nofollow noopener";
                }
            }
        },
        loadArticle(articleId) {
            let apiUrl = this.$store.getters.getApiUrl;
            axios
            .get(apiUrl + 'pages/' + articleId + "/")
            .then(response => {
                this.article = response.data;  
                this.articleType = this.article.meta.type;

                this.$nextTick( () => this.checkLinks() );
            })
            .catch(error => {
                console.log(error);
                // set article object to only contain id so the removeLike button can work
                this.errorLoadingArticle = true;
            });
        },
        isNumeric(str) {
            if (typeof str != "string") return false // we only process strings!  
            return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
                    !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
        },
    },
    mounted() {
        this.init(this.$route.params.id);
    },
    beforeRouteUpdate (to, from, next) {
        this.init(to.params.id);
        next();
    },
    computed: {
        baseUrl() {
            return this.$store.getters.getBaseUrl;
        }
    }
}
</script>

<style lang="scss">
    .contact_person {
        margin-top: 10px;
        margin-bottom: 20px;
        display:flex;
    }

    .contact_person img {
        margin-right: 10px;
        @media screen and (max-width: 767px) {
            max-width: 100px;
        }
    }

    .image_with_link {
        margin-top: 10px;
        margin-bottom: 20px;
        display:flex;
    }

    .image_with_link p {
        text-align: justify;
    }

    .image_with_link img {
        @media screen and (max-width: 767px) {
            max-width: 100px;
        }
    }

    .image_with_link_right img {
        margin: 20px 0 10px 20px;
    }
    .image_with_link_left img {
        margin: 20px 20px 10px 0;
    }

    img.full-width {
        max-width: 100%;
        height: auto!important;
    }

    .legal {
        padding: 16px 0;

        @media (min-width: $breakpoint-sm) {
            padding: 64px 0;
        }

        h1 {
            margin-bottom: 32px;

            @media (min-width: $breakpoint-sm) {
                margin-bottom: 48px;
            }
        }

        p {
            @media (min-width: $breakpoint-sm) {
                font-size: 17px;
                line-height: 24px;
            }
        }

        figure {
            display: flex;
            flex-direction: column;
            padding: 0;
            width: calc(100% + 48px);
            margin: 24px -24px;

            @media (min-width: $breakpoint-sm) {
                width: calc(100% + 64px);
                margin: 40px -32px;
            }
            
            img {
                width: 100%;
                height: 220px;
                object-fit: cover;

                @media (min-width: $breakpoint-sm) {
                    height: 460px;
                    border-radius: 8px;
                }
            }

            figcaption {
                padding: 8px 24px;
                box-shadow: inset 0 -1px 0 0 rgba($colorBlack, .08);

                @media (min-width: $breakpoint-sm) {
                    padding: 18px 0 2px;
                    box-shadow: none;
                }

                .caption {
                    font-size: 11px;
                    line-height: 16px;
                    font-weight: 600;

                    @media (min-width: $breakpoint-sm) {
                        font-weight: 700;
                        text-align: center;
                    }

                    &--text {
                        color: $colorBlack;

                        @media (min-width: $breakpoint-sm) {
                            font-size: 20px;
                            line-height: 26px;
                        }
                    }

                    &--credits {
                        color: rgba($colorBlack, .48);

                        @media (min-width: $breakpoint-sm) {
                            font-size: 14px;
                            line-height: 20px;
                        }
                    }
                }
            }
        }

    }
</style>